'use client';

import HomePageClient from '@/components/HomePageClient';

export default function HomePage() {
  return <HomePageClient />;
}
